import { Typography, Box, Paper } from '@mui/material';

interface RejectionCommentsProps {
  approvals?: Array<{ comments?: string; approver?: string; rejectDate?: string }>;
}

export function RejectionComments({ approvals }: RejectionCommentsProps) {
  const getRejectionComments = () => {
    if (!approvals || approvals.length === 0) {
      return 'Reason not included';
    }

    return (
      <ul style={{ margin: 0, paddingLeft: '20px' }}>
        {approvals.map((approval, index) => (
          <li key={index}>
            {approval.approver && <strong>{approval.approver}: </strong>}
            {approval.comments || 'Reason not included'}
            {approval.rejectDate && (
              <Typography variant="caption" sx={{ display: 'block', mt: 0.5, fontStyle: 'italic' }}>
                Rejected on {approval.rejectDate}
              </Typography>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Box sx={{ mb: 2, mt: 2 }}>
      <Typography variant="caption" color="error" sx={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
        Rejection Comments
      </Typography>
      <Paper variant="outlined" sx={{ p: 2, bgcolor: '#ffebee', mt: 0.5, borderColor: '#ffcdd2' }}>
        <Typography variant="body2" color="error.dark">
          {getRejectionComments()}
        </Typography>
      </Paper>
    </Box>
  );
}